/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ConsultationStrictHttpResponse } from '../../consultation-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EncounterModel } from '../../models/encounter-model';

export interface EncounterPatientEncountersPatientFhirIdGet$Params {
  patientFhirId: string;
}

export function encounterPatientEncountersPatientFhirIdGet(http: HttpClient, rootUrl: string, params: EncounterPatientEncountersPatientFhirIdGet$Params, context?: HttpContext): Observable<ConsultationStrictHttpResponse<Array<EncounterModel>>> {
  const rb = new RequestBuilder(rootUrl, encounterPatientEncountersPatientFhirIdGet.PATH, 'get');
  if (params) {
    rb.path('patientFhirId', params.patientFhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as ConsultationStrictHttpResponse<Array<EncounterModel>>;
    })
  );
}

encounterPatientEncountersPatientFhirIdGet.PATH = '/Encounter/PatientEncounters/{patientFhirId}';
